import React from "react";

export default function File({ color = "#424242", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={20}
      viewBox="0 0 15 20"
      {...restProps}
    >
      <path
        fill={color}
        fillRule="nonzero"
        d="M14.45 3.715L11.171.535A1.904 1.904 0 0 0 9.848 0H1.875C.84.004 0 .819 0 1.823v15.77c0 1.004.84 1.819 1.875 1.819h11.25c1.035 0 1.875-.815 1.875-1.82V5.004c0-.482-.2-.948-.55-1.29zm-1.477 1.14H10V1.972l2.973 2.885zM1.875 17.593V1.823h6.25v3.943c0 .504.418.91.938.91h4.062v10.916H1.875z"
      />
    </svg>
  );
}
